import { take } from "../util/takePayload";
export const fromGql = (config) => take(config, 'workspaceKey', 'eventKey', 'region', 'objectWithoutPricingSelectable');
//# sourceMappingURL=CheckoutSeatsioConfig.js.map